var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['popup', _vm.type, {'active': _vm.show}]},[_c('div',{staticClass:"popup__bg",on:{"click":function($event){return _vm.$emit('close')}}}),_c('div',{class:['popup__content', _vm.size]},[_c('div',{staticClass:"popup__close",on:{"click":function($event){return _vm.$emit('close')}}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }